import { Row } from "@tanstack/react-table";

export interface ActivityRecord {
    id: number;
    action: string;
    date: string;
    userId: number;
    userName: string;
    changeType: number;
    targetArea: number;
}

export interface FetchHistoryService {
    totalHistories: number;
    filteredHistoriesCount: number;
    histories: ActivityRecord[];
}

export interface FetchQuiresHistory {
    userId?: number;
    pageNumber?: number;
    pageSize?: number;
    startDate?: number;
    endDate?: number;
    targetArea?: number;
    changeType?: number;
}

export enum ChangeType {
    Created = 0, // User|Product| ChangeTypeProduct
    Updated = 1, // User ChangeType
    Deleted = 2, // User ChangeType
    Deactivated = 3, // License ChangeType
    Expired = 4, // License ChangeType
    Transaction = 5, //License ChangeType
}

export enum TargetArea {
    User = 0,
    License = 1,
    Product = 2,
    Project = 3,
    Migration = 4,
    Feature = 5,
}

export type renderSubComponentActivityRecordTable = {
    (props: {
        row: Row<ActivityRecord>;
        subRowHandler?: (id: number) => void;
    }): JSX.Element;
};

export interface HistoryTable extends ActivityRecord {
    subRows?: ActivityRecord;
}
